import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderRowComponent } from './header-row.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [HeaderRowComponent],
  imports: [CommonModule, FormsModule, BsDropdownModule.forRoot()],
  exports: [HeaderRowComponent]
})
export class HeaderRowModule {}
